import React from 'react';
import { Typography, Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

const EmailSubscription = ({ booking, onCheckboxChange, variant = 'body2', sx }) => {
    const { t } = useTranslation();

    return (
        <FormControlLabel
            sx={sx}
            control={
                <Checkbox
                    checked={booking.subscribed}
                    onChange={onCheckboxChange}
                    name="subscribed"
                    slotProps={{ input: { autoComplete: 'off' } }}
                />
            }
            label={<Typography variant={variant}>{t('booking.acceptSubscription')}</Typography>}
        />
    );
};

export { EmailSubscription };
